import React from "react";
import { useForm } from "react-hook-form";
import FormBox from "../../../components/FormBox/FormBox";
import PopupWrapper from "../../../components/PopupWrapper";
import { Button } from "react-bootstrap";

const ModalForm = ({ show, setShow, title = "" }) => {
  const { register, handleSubmit, watch, setValue } = useForm();

  function onSubmit(data) {}

  return (
    <PopupWrapper
      title={title}
      extraClass="width-800"
      backdrop="static"
      Component={
        <div>
          <form>
            <FormBox
              options={formArr}
              register={register}
              watch={watch}
              setValue={setValue}
            />
            <div className="text-end">
              <Button
                className="text-white mt-5"
                  onClick={handleSubmit(onSubmit)}
              >
                Create
              </Button>
            </div>
          </form>
        </div>
      }
      toShow={show}
      closeEventHandler={() => {
        setShow(false);
      }}
    />
  );
};

export default ModalForm;

const formArr = [
  {
    title: "First Name",
    field: "firstName",
    type: "text",
    className: "col-4",
  },
  {
    title: "Middle Name",
    field: "middleName",
    type: "text",
    className: "col-4",
  },
  {
    title: "Last Name",
    field: "lastName",
    type: "text",
    className: "col-4",
  },
  {
    title: "Sort Name",
    field: "sortName",
    type: "text",
    className: "col-4",
  },
  {
    title: "By Last Name",
    field: "byLastName",
    type: "text",
    className: "col-4",
  },
  {
    title: "Full Name",
    field: "fullName",
    type: "text",
    className: "col-4",
  },
  {
    title: "Salutation",
    field: "salutation",
    type: "text",
    className: "col-4",
  },
  {
    title: "Street",
    field: "street",
    type: "text",
    className: "col-4",
  },
  {
    title: "City",
    field: "city",
    type: "text",
    className: "col-4",
  },
  {
    title: "State",
    field: "state",
    type: "text",
    className: "col-4",
  },
  {
    title: "Zipcode",
    field: "zipcode",
    type: "text",
    className: "col-4",
  },
  {
    title: "Phone (Home)",
    field: "phoneHome",
    type: "text",
    className: "col-4",
  },
  {
    title: "Phone (Work)",
    field: "phoneWork",
    type: "text",
    className: "col-4",
  },
  {
    title: "Phone (Cell)",
    field: "phoneCell",
    type: "text",
    className: "col-4",
  },
  {
    title: "Fax",
    field: "fax",
    type: "text",
    className: "col-4",
  },
  {
    title: "Phone (Main)",
    field: "phoneMain",
    type: "text",
    className: "col-4",
  },
  {
    title: "Tin",
    field: "tin",
    type: "text",
    className: "col-4",
  },
  {
    title: "Email",
    field: "email",
    type: "text",
    className: "col-4",
  },
];
